import {
  PersonalizationSettings,
  PersonalizationSettingsCategory,
  PersonalizationSettingsChannel,
} from '@/api/apis/communication/personalization';

export const personalizationSettingsAvailable = (settings?: PersonalizationSettings): boolean => {
  return (
    settings?.categories?.some(
      (category) => category.visible && category.notifications?.some((notification) => notification.visible),
    ) ?? false
  );
};

export const preparePersonalizationSettings = (settings?: PersonalizationSettings): PersonalizationSettings => {
  return {
    categories:
      settings?.categories
        ?.filter((category) => category.visible)
        .map((category) => ({
          ...category,
          notifications:
            category.notifications
              ?.filter((notification) => notification.visible)
              .map((notification) => ({
                ...notification,
                channels: notification.channels?.filter((channel) => channel.visible) ?? [],
              })) ?? [],
        })) ?? [],
  };
};

export const getCategoryEnabledEventsInfo = (category: PersonalizationSettingsCategory): string => {
  const enabledTotal = category.notifications.filter((event) =>
    event.channels.some((channel) => channel.visible && channel.enabled),
  ).length;
  const channelsTotal = category.notifications.length;
  return `${enabledTotal} of ${channelsTotal}`;
};

export const getGroupStatus = (channels: PersonalizationSettingsChannel[]): 'on' | 'off' | 'partially_on' => {
  if (!channels.length) return 'off';
  const allTrue = channels.every((c) => c.enabled);
  const allFalse = channels.every((c) => !c.enabled);
  if (allTrue) return 'on';
  if (allFalse) return 'off';
  return 'partially_on';
};
